module.exports = __webpack_public_path__ + "static/media/centralSeatPremierOneTaken.b0e72795.svg";